import { render, staticRenderFns } from "./socsosubGrid.vue?vue&type=template&id=27e12924"
import script from "./socsosubGrid.vue?vue&type=script&lang=js"
export * from "./socsosubGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports